import React from 'react'
import { Title } from 'components/atoms'
import { Modal } from 'components/molecules'
import { PageCreateForm } from 'components/organisms'
import PropTypes from 'prop-types'
import { useParams, useHistory } from 'react-router-dom'
import { createPage } from 'services/requests'
import { toast } from 'react-toastify';
import { Toast } from 'containers';
import { generateEditorPath } from 'services/generators'

const PageCreateModal = ({ isOpen, toggle }) => {
  const { subweb, lang: langParam } = useParams()
  const history = useHistory()
  const lang = langParam || 'pt'

  const handleSubmit = async ({ slug, title }) => {
    try {
      const { data: { pageId } } = await createPage({ slug, title, subweb })
      toast.success(
        <Toast
          type="success"
          title="Página criada"
          description={`versão ${lang}`}
        />
      );
      const editorPath = generateEditorPath({ lang: 'pt', subweb, pageId })
      history.push(editorPath)
    } catch (err) {
      if (err.response && err.response.status === 409) {
        toast.error(
          <Toast
            type="error"
            title="Slug já está a ser utilizado."
            description={err.message}
          />
        );
      } else {
        toast.error(
          <Toast
            type="error"
            title="Erro a criar página."
            description={err.message}
          />
        );
      }
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top>
        <Title>
          Criar página
        </Title>
      </Modal.Top>
      <PageCreateForm
        subweb={subweb}
        lang={lang}
        onSubmit={handleSubmit}
        onDiscard={toggle}
      />
    </Modal>
  )
}

PageCreateModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
}

PageCreateModal.defaultProps = {
  isOpen: false,
  toggle: () => {}
}

export default PageCreateModal
